import * as React from 'react';
import { InputGroup } from '@mc/react-core';
import { Rifm } from 'rifm';

import classNames from 'classnames';

const numberAccept = /[\d.]+/g;

const parseNumber = (str: string) => (str.match(numberAccept) || []).join('');

export const formatFixedPointNumber = (value?: string, digits = 2) => {
  if (value == '' || value == undefined) {
    return '';
  }
  const parsed = parseNumber(value);
  const [head, tail] = parsed.split(value.includes('.') ? '.' : ',');
  // Avoid rounding errors at toLocaleString as when user enters 1.239 and maxDigits=2 we
  // must not to convert it to 1.24, it must stay 1.23
  const scaledTail = tail != null ? tail.slice(0, digits) : '';

  let number = Number.parseFloat(`${head}.${scaledTail}`);
  // For fixed format numbers deleting "." must be no-op
  // as imagine u have 123.45 then delete "." and get 12345.00 looks bad in UI
  // so we transform here 12345 into 123.45 instead of 12345.00.
  // The main disadvantage of this, that you need carefully check input value
  // that it always has fractional part
  if (digits > 0 && tail == null) {
    const paddedHead = head.padStart(digits + 1 - head.length, '0');
    number = Number.parseFloat(
      `${paddedHead.slice(0, -digits)}.${paddedHead.slice(-digits)}`
    );
  }

  if (Number.isNaN(number)) {
    return '';
  }

  const formatted = number.toLocaleString('cs', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });

  return formatted;
};

export type NumProps = Omit<
  React.ComponentProps<typeof InputGroup> & {
    currency?: React.ReactNode;
    precision?: number;
    inputClassName?: string;
  },
  'onChange' | 'rightElement'
> & { onChange: (value: string) => void };
export const CurrencyNumber = React.forwardRef<HTMLInputElement, NumProps>(
  (
    {
      value,
      onChange,
      inputClassName,
      required,
      disabled,
      currency = 'Kč',
      precision = 2,
      ...other
    },
    ref
  ) => {
    return (
      <Rifm
        accept={/[\d.]/g}
        value={value === undefined ? '' : String(value)}
        onChange={onChange}
        format={(v) => formatFixedPointNumber(v, precision)}
      >
        {({ value, onChange }) => (
          <InputGroup
            className={classNames(inputClassName, 'bp3-fill')}
            // @ts-ignore
            ref={ref}
            {...other}
            presi
            disabled={disabled}
            onChange={onChange}
            maxLength={16}
            rightElement={<span style={{ padding: '5px' }}>{currency}</span>}
            style={{ textAlign: 'right' }}
            value={value}
          />
        )}
      </Rifm>
    );
  }
);
